module.exports = __webpack_public_path__ + "img/fastcharger-suggestion.034a4e7c.svg";